<template>
  <div class="house-box" :style="{ height: height || '100%' }">
    <div class="houseTableBox">
      <div class="header" style="display: none">
        <div class="areaL">
          <div
            class="list"
            v-for="(item, index) in lpbList"
            :key="index"
            @click="() => handleLjzClick(item)"
          >
            <span class="name">
              {{ item.ljzmc }}
              <span class="selectBox" v-show="item.ljzcode === curLjzCode">
                <el-icon class="icon"><Check /></el-icon>
              </span>
            </span>
          </div>
        </div>
        <div class="areaRight">
          <!-- <el-select style="width: 100px">
							<el-option :label="item.number" :value="item.number" v-for="(item, index) in unitHouseData" :key="index" />
						</el-select> -->
          <el-input
            v-model="queryHouseKeywords"
            size="small"
            style="width: 80px; margin: 0 10px"
            placeholder="请输入户号"
          />
          <el-tooltip
            class="box-item"
            effect="dark"
            content="定位房屋"
            placement="top-start"
          >
            <el-icon class="icon cus" @click="handleZoomToHouse">
              <HelpFilled />
            </el-icon>
          </el-tooltip>
          <!-- <el-tooltip class="box-item" effect="dark" content="切换列表视图" placement="top-start">
						<el-icon class="icon cus" style="margin: 0 10px" v-if="isShowTable" @click="isShowTable = false"><Expand /></el-icon>
						<el-icon class="icon cus" style="margin: 0 10px" v-else @click="isShowTable = true"><Menu /></el-icon>
					</el-tooltip> -->
        </div>
      </div>
      <div class="content">
        <div class="contentL" v-if="isShowTable">
          <div
            class="tableList"
            v-for="(item, index) in unitHouseData"
            :key="index"
          >
            <div class="tableH">
              {{ dyhInfo[item.number] || item.number }}
            </div>
            <div
              class="tableL"
              v-for="(itemL, indexL) in item.children"
              :key="indexL"
            >
              <span class="left">
                {{ itemL.number }}
              </span>
              <span
                :class="[
                  'right',
                  { highlight: itemLL.highlight, disabled: !itemLL.checkable },
                ]"
                v-for="(itemLL, indexLL) in itemL.children"
                :key="indexLL"
                :title="`房号:${itemLL.fh}\n建筑面积:${
                  itemLL.ycjzmj || itemLL.scjzmj || itemLL.jzmj
                }\n房屋用途:${itemLL.fwytmc}\n状态:${itemLL.statusDesc}`"
              >
                <span style="text-align: left; width: 160px">
                  <div style="display: flex; justify-content: space-between">
                    <span class="houseNumber" @click="handleHClick(itemLL)">
                      {{ itemLL.fh }}
                    </span>
                    <span class="statusBox" @click="getCheckData(itemLL)">
                      <span
                        v-for="statusItem in itemLL.status"
                        :key="statusItem.name"
                        :style="`background:${statusItem.color}`"
                        :title="statusItem.name"
                      ></span>
                    </span>
                  </div>
                  <div style="font-size: 12px">
                    {{
                      `建筑面积:${
                        itemLL.ycjzmj || itemLL.scjzmj || itemLL.jzmj
                      }`
                    }}
                  </div>
                  <div style="font-size: 12px">
                    {{ `房屋用途:${itemLL.fwytmc}` }}
                  </div>
                </span>

                <span class="rightSelectBox" @click="getCheckData(itemLL)">
                  <span
                    class="triangle"
                    v-show="checkedHouses.includes(itemLL.fwcode)"
                  >
                    <el-icon class="icon"><Check /></el-icon>
                  </span>
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="contentL" v-else>
          <es-table
            ref="tableRef"
            :list="list"
            :columns="columns"
            :serialProps="{ fixed: 'left' }"
          />
        </div>
        <div class="contentR">
          <p
            v-for="(item, index) in houseStatus"
            :key="index"
            style="display: flex; align-items: center"
          >
            <span
              class="statusBox"
              :style="{ 'background-color': item.color }"
            ></span>
            <span style="font-size: 12px">{{ item.name }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup name="component-lpb">
import { ref, watch, onMounted } from 'vue';
import { getHouseListRe, queryDictRe } from '@/api/common';
import { EsDialog, EsTable } from '@escon/escon-ui';
import { ElMessage } from 'element-plus';
import { useRoute } from 'vue-router';

const emits = defineEmits(['change']);
const props = defineProps({
  // 是否只读
  disabled: Boolean,
  // 数据源ID
  dsId: String,
  // 楼盘表高度
  height: String,
  // 默认选中项
  checkedFwcodes: Object,
  // 是否多选
  multiple: Boolean,
  // 选择模式 wqba|fwyd
  selectMode: String,
});
const route = useRoute();

// 逻辑幢列表
const lpbList = ref([]);
// 当前选中逻辑幢
const curLjzCode = ref();
// 当前查询房屋号
const queryHouseKeywords = ref();
// 是否可编辑房屋
const houseEditable = ref(false);

const columns = ref([
  {
    label: '套内面积（m2）',
    prop: 'tnmj',
  },
  {
    label: '分摊面积（m2）',
    prop: 'ftmj',
  },
  {
    label: '建筑面积',
    prop: 'jzmj',
  },
  {
    label: '房屋用途',
    prop: 'fwyt',
  },
  {
    label: '房屋性质',
    prop: 'fwxz',
  },
  {
    label: '户型居室',
    prop: 'hxjs',
  },
  {
    label: '房屋朝向',
    prop: 'fwcx',
  },
  {
    label: '户型结构',
    prop: 'hxjg',
  },
  {
    label: '房屋类型',
    prop: 'fwlxzt',
  },
]);

const houseStatus = ref([
  {
    name: '可售',
    color: 'rgb(0, 253, 18)',
  },
  {
    name: '不可售',
    color: 'rgb(239, 253, 0)',
  },
  {
    name: '存量房',
    color: 'rgb(101, 203, 155)',
  },
  {
    name: '商品房',
    color: 'rgb(192, 210, 68)',
  },
  {
    name: '已售',
    color: 'rgb(142, 142, 143)',
  },
  {
    name: '已备案',
    color: 'rgb(14, 0, 255)',
  },
  {
    name: '首登所有权',
    color: 'rgb(67, 101, 24)',
  },
  {
    name: '非首登所有权',
    color: 'rgb(213, 237, 198)',
  },
  {
    name: '抵押',
    color: 'rgb(143, 85, 106)',
  },
  {
    name: '在建工程抵押',
    color: 'rgb(229, 31, 239)',
  },
  {
    name: '所有权预告',
    color: 'rgb(141, 186, 241)',
  },
  {
    name: '抵押权预告',
    color: 'rgb(231, 224, 234)',
  },
  // 查封 cfzt === 1
  {
    name: '查封',
    color: 'rgb(252, 149, 5)',
  },
  // 预查封 ycfzt === 1
  {
    name: '预查封',
    color: 'rgb(188, 129, 201)',
  },
  // 异议 yyzt === 1
  {
    name: '异议',
    color: 'rgb(136, 40, 75)',
  },
  // 地役 dyqzt === 1
  {
    name: '地役',
    color: 'rgb(238, 207, 141)',
  },
  // 锁定 nbxzzt === 1
  {
    name: '锁定',
    color: 'rgb(214, 51, 89)',
  },
  // 工抵房 nbxzzt === 2
  {
    name: '工抵房',
    color: 'rgb(238, 107, 141)',
  },
  // 还建房 nbxzzt === 3
  {
    name: '还建房',
    color: 'rgb(138, 107, 141)',
  },
  // 已预定 ydzt === 1
  {
    name: '已预定',
    color: 'rgb(151, 251, 244)',
  },
]);

const allHouseList = ref([]);
const list = ref([]);
// 选中房屋
const checkedHouses = ref([]);
const unitHouseData = ref([]);

// 房屋详情
const dialogVisible = ref(false);
const formValues = ref({});
const isShowTable = ref(true);
const formRef = ref();
const dyhInfo = ref({});
const curHInfo = ref();

onMounted(() => {
  queryLpbData();

  setTimeout(() => {
    updateCheckedHouses();
  }, 10);
});

watch(curLjzCode, () => {
  // 选中逻辑幢改变后，重新展示户
  const curList = allHouseList.value.filter(
    (item) => item.ljzcode === curLjzCode.value
  );
  unitHouseData.value = finallyData(curList);
  list.value = curList;
});

// 更新选中户
const updateCheckedHouses = () => {
  if (Array.isArray(props.checkedFwcodes)) {
    checkedHouses.value = [...props.checkedFwcodes];
  }
};

// 查询户列表
async function queryLpbData() {
  const zrzcode = route.query.zrzcode;

  // 查询所有户列表
  getHouseListRe({
    zrzcode,
  }).then(async (res) => {
    maintainLpbData(res.data);
  });
}

// 处理楼盘表返回数据
const maintainLpbData = async (resData) => {
  allHouseList.value = (resData || []).map((item) => {
    dyhInfo.value[item.dyxh] = item.dymc;
    return {
      ...item,
      hh: item.fh,
      shbw: item.fh,
      dyh: item.dyxh || 1,
      dymc: item.dymc,
      sjc: item.sjc || item.myc,
    };
  });
  // 维护户状态
  maintainHouseStatus(allHouseList.value);
  maintainHouseCheckable(allHouseList.value);
  // 维护房屋用途字典wxzj_fwyt
  const dictList = await queryDictRe('wxzj_fwyt');
  if (dictList && dictList.length > 0) {
    allHouseList.value.forEach((item) => {
      item.fwytmc = item.fwyt;
      const findItem = dictList.find(
        (dictItem) => dictItem.value === item.fwyt
      );
      if (findItem) {
        item.fwytmc = findItem.label;
      }
    });
  }
  list.value = allHouseList.value;
  const curList = allHouseList.value;
  unitHouseData.value = finallyData(curList);
  if (lpbList.value.length > 0) {
    curLjzCode.value = lpbList.value[0].ljzcode;
  }
};

const finallyData = (list) => {
  const newArr = [];
  let maxNumOne = Math.max.apply(
    Math,
    list.map((item) => {
      return item.dyxh;
    })
  );
  let maxNumTwo = Math.max.apply(
    Math,
    list.map((item) => {
      return item.sjc;
    })
  );
  for (var i = 0; i < maxNumOne; i++) {
    if (list.find((listItem) => listItem.dyxh === i + 1)) {
      newArr.push({
        number: i + 1,
        children: [],
      });
    }
  }

  for (let index = 0; index < maxNumTwo; index++) {
    newArr.forEach((key) => {
      key.children.push({
        number: index + 1,
        children: [],
      });
    });
  }

  newArr.forEach((key) => {
    list.forEach((item) => {
      if (key.number == item.dyxh) {
        key.children.forEach((child) => {
          if (child.number == item.sjc) {
            child.children.push({ ...item, isCheck: false });
          }
        });
      }
    });
    key.children.sort((item1, item2) => item2.number - item1.number);
  });
  return newArr;
};

// 维护户状态
const maintainHouseStatus = (list) => {
  if (!Array.isArray(list)) {
    return;
  }

  list.forEach((item) => {
    item.status = [];
    if (item.yszt === '1' || item.xszt === '1') {
      // 可售
      item.status.push('可售');
    }
    if (item.yszt === '3' || item.zlhtzt === '3') {
      // 不可售
      item.status.push('不可售');
    }
    if (item.fwlxzt === '2') {
      // 存量房
      item.status.push('存量房');
    } else {
      // 商品房
      item.status.push('商品房');
    }
    if (item.xjfbazt === '2' || item.xjfbazt === '2') {
      // 已售
      item.status.push('已售');
    }
    if (item.xjfbazt === '1' || item.clfbazt === '1') {
      // 已备案
      item.status.push('已备案');
    }
    if (item.scdjsyqzt === '1') {
      // 首登所有权
      item.status.push('首登所有权');
    }
    if (item.fscdjsyqzt === '1') {
      // 非首登所有权
      item.status.push('非首登所有权');
    }
    if (item.xfdyqzt === '1') {
      // 抵押
      item.status.push('抵押');
    }
    if (item.zjgcdyqzt === '1') {
      // 在建工程抵押
      item.status.push('在建工程抵押');
    }
    if (item.syqygzt === '1') {
      // 所有权预告
      item.status.push('所有权预告');
    }
    if (item.dyqygzt === '1') {
      // 抵押权预告
      item.status.push('抵押权预告');
    }
    if (item.cfzt === '1') {
      // 查封
      item.status.push('查封');
    }
    if (item.ycfzt === '1') {
      // 预查封
      item.status.push('预查封');
    }
    if (item.yyzt === '1') {
      // 异议
      item.status.push('异议');
    }
    if (item.dyqzt === '1') {
      // 地役
      item.status.push('地役');
    }
    if (item.nbxzzt === '1') {
      // 锁定
      item.status.push('锁定');
    }
    // 工抵房 nbxzzt === 2
    if (item.nbxzzt === '2') {
      // 工抵房
      item.status.push('工抵房');
    }
    // 还建房 nbxzzt === 3
    if (item.nbxzzt === '3') {
      // 还建房
      item.status.push('还建房');
    }
    // 已预定 ydzt === 1
    if (item.ydzt === '1') {
      // 已预定
      item.status.push('已预定');
    }
    item.status = item.status.map((statusItem) => {
      return {
        name: statusItem,
        color: getStatusColor(statusItem),
      };
    });
    item.statusDesc = item.status.map((item) => item.name).join(',');
    // 只展示前三个状态
    item.allstatus = [...item.status];
    item.status = item.allstatus.filter((item, index) => index <= 2);
  });
};

// 维护户可选状态
const maintainHouseCheckable = (list) => {
  if (!Array.isArray(list)) {
    return;
  }
  list.forEach((item) => {
    item.checkable = false;
    if (props.selectMode === 'wqba') {
      // 网签备案
      if (item.yszt === '1') {
        // 预售
        if (
          item.fwlxzt === '1' &&
          item.xjfbazt === '0' &&
          item.scdjsyqzt === '0' &&
          item.fscdjsyqzt === '0' &&
          item.xfdyqzt === '0' &&
          item.zjgcdyqzt === '0' &&
          item.syqygzt === '0' &&
          item.cfzt === '0' &&
          item.ycfzt === '0' &&
          item.yyzt === '0' &&
          item.nbxzzt === '0'
        ) {
          item.checkable = true;
        }
      } else if (item.xszt === '1') {
        // 现售
        if (
          item.fwlxzt === '1' &&
          item.xjfbazt === '0' &&
          item.scdjsyqzt === '1' &&
          item.fscdjsyqzt === '0' &&
          item.xfdyqzt === '0' &&
          item.zjgcdyqzt === '0' &&
          item.syqygzt === '0' &&
          item.cfzt === '0' &&
          item.ycfzt === '0' &&
          item.yyzt === '0' &&
          item.nbxzzt === '0'
        ) {
          item.checkable = true;
        }
      }
    } else if (props.selectMode === 'fwyd') {
      // 房屋预定
      if (
        (item.xszt === '1' || item.yszt === '1') &&
        item.fwlxzt === '1' &&
        item.xjfbazt === '0' &&
        item.fscdjsyqzt === '0' &&
        item.xfdyqzt === '0' &&
        item.zjgcdyqzt === '0' &&
        item.syqygzt === '0' &&
        item.cfzt === '0' &&
        item.ycfzt === '0' &&
        item.yyzt === '0' &&
        item.nbxzzt === '0' &&
        item.ydzt === '0'
      ) {
        item.checkable = true;
      }
    }
  });
};

// 获取状态颜色
const getStatusColor = (name) => {
  const findItem = houseStatus.value.find((item) => item.name === name);
  return (findItem && findItem.color) || '';
};

// 逻辑幢点击事件
const handleLjzClick = (ljzItem) => {
  curLjzCode.value = ljzItem.ljzcode;
};

// 户点击查看详情事件
const handleHClick = (hInfo) => {
  if (!hInfo.fwcode) {
    ElMessage.error('缺失fwcode,无法查看！');
    return;
  }
  curHInfo.value = hInfo;
  formValues.value = JSON.parse(JSON.stringify({ chcg_fw: hInfo }));
  dialogVisible.value = true;
};

//点击勾选
const getCheckData = (item) => {
  // if (props.disabled) {
  // 	return;
  // }
  if (!item.checkable) {
    return;
  }
  if (props.multiple) {
    // 多选
    if (checkedHouses.value.includes(item.fwcode)) {
      checkedHouses.value.splice(
        checkedHouses.value.findIndex((findItem) => findItem === item.fwcode),
        1
      );
    } else {
      checkedHouses.value.push(item.fwcode);
    }
    emits(
      'change',
      checkedHouses.value.map((checkedFwcode) =>
        allHouseList.value.find((findItem) => findItem.fwcode === checkedFwcode)
      )
    );
  } else {
    if (checkedHouses.value[0] === item.fwcode) {
      checkedHouses.value = [];
      emits('change', null);
    } else {
      checkedHouses.value = [item.fwcode];
      emits('change', item);
    }
  }
};

// 定位到具体房屋
const handleZoomToHouse = () => {
  let bHighlight = false;
  unitHouseData.value.forEach((unitItem) => {
    if (Array.isArray(unitItem.children)) {
      unitItem.children.forEach((cItem) => {
        if (Array.isArray(cItem.children)) {
          cItem.children.forEach((hItem) => {
            hItem.highlight = hItem.shbw === queryHouseKeywords.value;
            if (hItem.highlight) {
              bHighlight = true;
            }
          });
        }
      });
    }
  });
  unitHouseData.value = [...unitHouseData.value];
  if (!bHighlight) {
    ElMessage.info('没有匹配到房屋，请输入完整的房号！');
  }
};

// 房屋弹框确认
const handleOk = () => {
  formRef.value.validateForm().then((form) => {
    const saveValues = { ...form.values };
    window.$functions.fw_zt_er_updateAsync(saveValues).then(() => {
      ElMessage.success('编辑成功！');
      dialogVisible.value = false;
      Object.assign(curHInfo.value, saveValues.chcg_fw, {
        ...saveValues.chcg_fwztb,
        fwlxzt: saveValues.chcg_fwztb.fwlx,
      });
      maintainHouseStatus([curHInfo.value]);
      maintainHouseCheckable([curHInfo.value]);
      lpbList.value = [...lpbList.value];
    });
  });
};
</script>
<style lang="scss">
.house-box {
  padding: 20px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  .houseTableBox {
    display: flex;
    height: 100%;
    flex-direction: column;
    .header {
      margin: 0 0 10px 0;
      background-color: #669aff;
      height: 40px;
      line-height: 40px;
      color: #fff;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      .areaL {
        display: flex;
        align-items: center;
        .list {
          margin-left: 10px;
        }
        .name {
          border: 2px solid #275cc4;
          padding: 2px 12px;
          position: relative;
          cursor: pointer;
          .selectBox {
            position: absolute;
            right: 0px;
            bottom: 0px;
            width: 0px;
            height: 0px;
            border-bottom: 15px solid #275cc4;
            border-left: 15px solid transparent;
            .icon {
              position: absolute;
              right: 0px;
              top: 5px;
              color: #fff;
              font-size: 10px;
            }
          }
        }
      }
      .areaRight {
        display: flex;
        align-items: center;

        .icon {
          cursor: pointer;
        }
      }
    }
    .content {
      display: flex;
      flex: 1;
      min-height: 100px;
      .contentL {
        display: flex;
        flex: 1;
        height: 100%;
        overflow: auto;
        margin-right: 5px;

        .tableList {
          margin-right: 10px;
          margin-bottom: 10px;
          text-align: center;
          .tableH {
            background: #a3d5f6;
            padding: 5px 0;
            border-radius: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .tableL {
            margin-top: 5px;
            display: flex;
            align-items: center;
            height: 61px;
            .left {
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0 10px;
              width: 20px;
              background: #a3d5f6;
              border-radius: 5px;
              margin-bottom: 2px;
            }
            .right {
              border: 2px solid #ddd;
              border-radius: 5px;
              background-color: #f0f0f0;
              padding: 0 10px;
              margin: 0 5px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              flex-wrap: wrap;
              width: 140px;
              position: relative;
              cursor: pointer;
              &.highlight {
                box-shadow: rgb(0, 0, 255) 0px 0px 14px;
              }
              &.disabled {
                background: #fffefe;
                color: #b8b3b3;
                cursor: not-allowed;
              }
              .houseNumber {
                border-bottom: 1px solid #333;
                cursor: pointer;
              }
              .rightSelectBox {
                position: absolute;
                cursor: pointer;
                right: 0px;
                bottom: 0px;
                width: 20px;
                height: 20px;
                .triangle {
                  position: absolute;
                  right: 0px;
                  bottom: 0px;
                  width: 0px;
                  height: 0px;
                  border-bottom: 15px solid #275cc4;
                  border-left: 15px solid transparent;
                }
                .icon {
                  position: absolute;
                  right: 0px;
                  top: 5px;
                  color: #fff;
                  font-size: 10px;
                }
              }
              .statusBox {
                flex: 1;
                text-align: right;
                > span {
                  width: 12px;
                  height: 12px;
                  display: inline-block;
                  margin-right: 3px;
                }
              }
            }
          }
          .checkBox {
            margin-right: 5px;
          }
        }
      }
      .contentR {
        width: 135px;
        height: 100%;
        background: #eee;
        padding: 10px;
        overflow: auto;

        .statusBox {
          width: 16px;
          height: 16px;
          display: inline-block;
          margin-right: 10px;
          box-shadow: 2px 2px 0 rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
}
</style>
